import {
  Text,
  ReactTable,
  Box,
  IconButton,
  Icon,
  Flex,
} from '@wegroup/design-system';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell } from 'react-table';
import { GbiCode } from '../../../../types/CompanyScanTypes';
import TableFiller from '../common/TableFiller';

interface Props {
  gbiCodes: GbiCode[];
  onRemove: (index: number) => void;
  isDisabled?: boolean;
}

const GbiCodeTable = ({ gbiCodes, onRemove, isDisabled }: Props) => {
  const { t } = useTranslation();

  const renderCodeCell = (cell: Cell) => {
    const { code } = cell?.row?.original as GbiCode;

    return <Text>{code}</Text>;
  };

  const renderDescriptionCell = (cell: Cell) => {
    const { label } = cell?.row?.original as GbiCode;

    return <Text color="text.gray">{label}</Text>;
  };

  const renderActionMenuCell = (cell: Cell) => {
    const index = cell?.row?.index;

    return (
      <Flex justify="flex-end">
        <IconButton
          variant="dangerSecondary"
          icon={<Icon name="GeneralActionsThrash" />}
          onClick={() => onRemove(index)}
          aria-label="remove"
          isDisabled={isDisabled}
        />
      </Flex>
    );
  };

  const columns = useMemo(
    () => [
      {
        Header: t('GOUDSE_GBI_CODE'),
        accessor: 'type',
        Cell: renderCodeCell,
        isSticky: true,
      },
      {
        Header: t('GOUDSE_GBI_DESCRIPTION'),
        accessor: 'duration',
        Cell: renderDescriptionCell,
      },
      {
        Header: t('ACTIONS'),
        id: 'actions',
        Cell: renderActionMenuCell,
        disableSortBy: true,
      },
    ],
    [gbiCodes],
  );

  return (
    <Box>
      <ReactTable
        data={gbiCodes}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        columns={columns as any}
      />
      {gbiCodes.length === 0 && (
        <TableFiller>
          <Text>{t('FLOWS_COMPANY-SCAN_GBI-INPUT_EMPTY-TABLE')}</Text>
        </TableFiller>
      )}
    </Box>
  );
};

export default GbiCodeTable;
